<ng-container [caLocalizationScope]="localizationScope">
  @if (templatesStore.loadStatus() === LoadStatus.Loading) {
  <div class="mt-5">
    <f-skeleton-drawer></f-skeleton-drawer>
  </div>
  } @else { @if (templatesStore.templates().length) {
  <p class="mt-5">
    {{ reportType() | caLocalize }}
    {{ 'configurableReportDescription' | caLocalize }}
  </p>
  <f-list class="mt-4" [withDividers]="true" [selectable]="true">
    @for (template of templatesStore.templates(); track template.templateId) {
    <f-list-item
      class="ca-template-list"
      [withHover]="false"
      (click)="onTemplateSelected(template)"
      [class.selected]="templatesStore.selectedTemplate()?.templateId === template.templateId"
    >
      <div class="w-100">
        <div data-automation-id="first-line" class="text-truncate d-flex align-items-center">
          <span [title]="template.templateName" class="flex-shrink-1 text-truncate">{{ template.templateName }}</span>
          <i
            class="f-i f-i-star f-i-sm ps-1 pb-1 text-primary-600"
            data-automation-id="default-template-icon"
            *ngIf="template.templateId === templatesStore.defaultTemplateId()"
            fMobilePopover
            #popover="ngbPopover"
            [ngbPopover]="'defaultTemplateMessage' | caLocalize : { ReportyType: (reportType() | titlecase) }"
            triggers="hover focus"
            container="body"
            placement="bottom"
          ></i>
        </div>
        @if (template.description) {
        <div class="body-50 text-truncate" [title]="template.description">
          {{ template.description }}
        </div>
        } @else {
        <div class="list-group-secondary-text" [title]="'noDescription' | caLocalize">
          {{ 'noDescription' | caLocalize }}
        </div>
        } @let lastUpdated = 'lastUpdatedOn' | caLocalize : { name: (template.updatedBy || template.createdBy) |
        caAccountUserFullName, date: (template.updatedDttm || template.createdDttm).toString() | caDate };
        <div
          class="list-group-secondary-text text-truncate mt-1"
          data-automation-id="second-line"
          [title]="lastUpdated"
        >
          {{ lastUpdated }}
        </div>
      </div>
    </f-list-item>
    }
  </f-list>
  <div class="mt-4">
    <span
      class="body-70 link link-primary"
      data-automation-id="create template"
      [ngClass]="{
        'disabled cursor-not-allowed': isCreateTemplateDisabled
      }"
      (click)="!isCreateTemplateDisabled && createTemplate()"
      [title]="
        (isCreateTemplateDisabled ? 'templatesLimitReached' : 'createTemplate')
          | caLocalize : { size: MAX_TEMPLATES_PER_ACCOUNT }
      "
      (keyup.enter)="!isCreateTemplateDisabled && createTemplate()"
    >
      + {{ 'createTemplate' | caLocalize }}
    </span>
  </div>
  <ca-set-as-default-toggle
    class="mt-5"
    [control]="setAsDefaultControl"
    [toggleLabel]="profileType() + 'ConfigurableToggleLabel'"
  ></ca-set-as-default-toggle>
  } @else {
  <div class="position-relative h-100">
    <f-simple-actionable-empty-state
      [caption]="'noTemplatesCaption' | caLocalize"
      [info]="'noTemplatesInfo' | caLocalize"
      [note]="'noTemplatesNote' | caLocalize"
      [simpleActionableOption]="SimpleActionableEmptyStatesOptions.EditHistory"
    >
      <a
        fEmptyStatesActions
        class="link link-primary text-center"
        data-automation-id="create-template-btn"
        [ngClass]="{
          'disabled cursor-not-allowed': isCreateTemplateDisabled
        }"
        (click)="!isCreateTemplateDisabled && createTemplate()"
        [title]="
          (isCreateTemplateDisabled ? 'templatesLimitReached' : 'createTemplate')
            | caLocalize : { size: MAX_TEMPLATES_PER_ACCOUNT }
        "
      >
        + {{ 'createTemplate' | caLocalize }}
      </a>
    </f-simple-actionable-empty-state>
  </div>
  } }
</ng-container>
